import GeneralHelper from '../../00_utilities/helpers/GeneralHelper';

class PageHeader {
    constructor(elem) {
        this.elem = elem;
        this.lastScrollTop = 100000;
        this.startToScrollPosition = 200;
    }

    init() {
        this.behaviourOnScroll();
    }

    behaviourOnScroll() {
        window.addEventListener('scroll', GeneralHelper.throttle(() => {
            if (!document.getElementById('main-menu-toggle').checked) {
                const scrollPosition = document.documentElement.scrollTop;
                if (scrollPosition > this.lastScrollTop && scrollPosition > this.startToScrollPosition) {
                    this.elem.classList.add('page-header--away');
                } else {
                    this.elem.classList.remove('page-header--away');
                }
                this.lastScrollTop = scrollPosition <= 0 ? 0 : scrollPosition;
            }
        }, 80));
    }
}

export default PageHeader;
